interface Props {
    guestRating?: number;
    large?: boolean;
}

export const GuestRatingCircle = ({ guestRating, large = false }: Props) => {
    const guestRatingShort = guestRating > 0 ? guestRating : '';
    const guestRatingReadable = guestRating > 0 ? `Gjestevurdering ${guestRating} av 10` : 'Ingen gjestevurderinger';
    return (
        <div data-testid="guestRating" className={`rating-circle ${large ? 'rating-circle-large' : ''}`} aria-label={guestRatingReadable}>
            {guestRatingShort}
        </div>
    );
};
